import type { NewsItem, CarouselSlide } from '@/types';

export const news: NewsItem[] = [
  {
    id: 'nw001',
    title: '曼城主场战平利物浦，黑5指数升至赛季新高',
    summary: '一场高质量对攻战以 2:2 收场，双方合计 22 次射门，主队黑5综合指数升至 87.4，创下本赛季新高。',
    time: '10 分钟前',
    date: '2026-10-15',
    categoryId: 'football',
    eventId: 'ev001',
    tag: '实时',
  },
  {
    id: 'nw002',
    title: '湖人末节崩盘，凯尔特人客场完成逆转',
    summary: '客队末节连续命中五记三分，替补席贡献 42 分，最终 112:108 带走胜利。',
    time: '1 小时前',
    date: '2026-10-15',
    categoryId: 'basketball',
    eventId: 'ev004',
    tag: '战报',
  },
  {
    id: 'nw003',
    title: 'LPL 季后赛第三局：JDG 大龙团战领先 TES',
    summary: '第三局主队通过一波大龙团战建立经济优势，系列赛比分来到 2:1，比赛仍在进行中。',
    time: '1 小时前',
    date: '2026-10-15',
    categoryId: 'esports',
    eventId: 'ev006',
    tag: '进行中',
  },
  {
    id: 'nw004',
    title: '温网男单决赛回顾：阿尔卡拉斯决胜盘抢七夺冠',
    summary: '五盘大战历时两小时五十八分钟，主队一发得分率高达 78%，最终顶住压力捧起奖杯。',
    time: '1 天前',
    date: '2026-10-12',
    categoryId: 'tennis',
    eventId: 'ev008',
    tag: '回顾',
  },
  {
    id: 'nw005',
    title: 'CBA 焦点前瞻：辽宁主场迎战广东宏远',
    summary: '两队近年多次在总决赛相遇，本场对决被视为常规赛阶段的风向标，开局节奏值得关注。',
    time: '2 小时前',
    date: '2026-10-15',
    categoryId: 'basketball',
    eventId: 'ev005',
    tag: '前瞻',
  },
  {
    id: 'nw006',
    title: '米兰德比落幕：国际米兰定位球小胜',
    summary: '下半场的一次定位球成为全场唯一进球，双方门将均有精彩扑救，比赛节奏紧凑。',
    time: '1 天前',
    date: '2026-10-14',
    categoryId: 'football',
    eventId: 'ev003',
    tag: '战报',
  },
  {
    id: 'nw007',
    title: 'KPL 五局鏖战：成都 AG 超玩会决胜局取胜',
    summary: '主队在决胜局依靠稳守反击拿下比赛，控龙率 60%，野区资源争夺成为关键。',
    time: '2 天前',
    date: '2026-10-13',
    categoryId: 'esports',
    eventId: 'ev007',
    tag: '战报',
  },
  {
    id: 'nw008',
    title: 'NHL 常规赛：枫叶主场轻取闪电',
    summary: '主队第二节连续两次强打得分，门将全场完成 32 次扑救，最终 4:2 拿下胜利。',
    time: '5 小时前',
    date: '2026-10-15',
    categoryId: 'hockey',
    eventId: 'ev011',
    tag: '战报',
  },
  {
    id: 'nw009',
    title: 'MLB 世界大赛首战：道奇先下一城',
    summary: '第七局连续安打打下三分，主队 5:3 取胜，系列赛取得领先。',
    time: '6 小时前',
    date: '2026-10-15',
    categoryId: 'baseball',
    eventId: 'ev010',
    tag: '战报',
  },
  {
    id: 'nw010',
    title: '欧冠小组头名之争：拜仁将在主场迎战巴黎',
    summary: '两队均需三分巩固出线形势，主队高位压迫体系与客队快速反击的碰撞值得期待。',
    time: '3 小时前',
    date: '2026-10-15',
    categoryId: 'football',
    eventId: 'ev012',
    tag: '前瞻',
  },
  {
    id: 'nw011',
    title: 'ATP 上海大师赛：德约科维奇晋级半决赛',
    summary: '硬地赛场上主队底线相持稳定，破发点转化率达到 42%，顺利晋级半决赛。',
    time: '1 天前',
    date: '2026-10-14',
    categoryId: 'tennis',
    eventId: 'ev009',
    tag: '赛果',
  },
  {
    id: 'nw012',
    title: '国家德比前瞻：皇马与巴萨积分仅差两分',
    summary: '本场结果将直接影响争冠区排名，两队近六次交锋各有胜负，中场控制权是关键。',
    time: '4 小时前',
    date: '2026-10-15',
    categoryId: 'football',
    eventId: 'ev002',
    tag: '前瞻',
  },
];

export const carouselSlides: CarouselSlide[] = [
  {
    id: 'cs001',
    eventId: 'ev001',
    title: '英超焦点战 · 曼城 2:2 利物浦',
    subtitle: '黑5综合指数 87.4，创下本赛季新高，高节奏对攻贯穿全场。',
    league: '英格兰超级联赛',
    status: '进行中',
    image: 'https://readdy.ai/api/search-image?query=Wide%20angle%20of%20a%20floodlit%20football%20stadium%20at%20night%20with%20green%20pitch%20and%20blurred%20crowd%2C%20stylized%20dark%20cinematic%20editorial%20photography%20with%20deep%20navy%20and%20orange%20accents%2C%20no%20text&width=1600&height=900&seq=cs-hero-01&orientation=landscape',
  },
  {
    id: 'cs002',
    eventId: 'ev004',
    title: 'NBA 常规赛 · 湖人 108:112 凯尔特人',
    subtitle: '客队末节三分雨完成逆转，替补席贡献 42 分成为胜负分水岭。',
    league: 'NBA 常规赛',
    status: '已结束',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20indoor%20basketball%20arena%20with%20spotlights%20and%20glossy%20hardwood%20court%2C%20stylized%20dark%20cinematic%20sports%20photography%20with%20warm%20orange%20highlights%2C%20no%20text&width=1600&height=900&seq=cs-hero-02&orientation=landscape',
  },
  {
    id: 'cs003',
    eventId: 'ev008',
    title: '温网男单决赛 · 阿尔卡拉斯封王',
    subtitle: '五盘大战抢七取胜，一发得分率 78%，制胜分 54 分。',
    league: '温布尔登网球锦标赛',
    status: '已结束',
    image: 'https://readdy.ai/api/search-image?query=Grass%20tennis%20court%20under%20evening%20spotlights%20with%20net%20and%20empty%20stands%2C%20stylized%20dark%20editorial%20sports%20photography%20with%20deep%20blue%20and%20amber%20tones%2C%20no%20text&width=1600&height=900&seq=cs-hero-03&orientation=landscape',
  },
  {
    id: 'cs004',
    eventId: 'ev006',
    title: 'LPL 季后赛 · JDG 2:1 TES',
    subtitle: '大龙团战建立经济优势，一血率 67%，黑5指数 88.9 位居榜首。',
    league: '英雄联盟职业联赛',
    status: '进行中',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20large%20led%20screens%20and%20dramatic%20stage%20lighting%2C%20stylized%20dark%20cyber%20atmosphere%20with%20teal%20and%20amber%20accents%2C%20no%20text&width=1600&height=900&seq=cs-hero-04&orientation=landscape',
  },
];

export const heroFeatured = carouselSlides[0];